<template>
  <lu-vbox>
    <PageTitle :title='$t("Broker Environments")' @togglePageTitle='togglePageTitle' />

    <el-tree
      :data="model"
      ref='brokerTree'
      style='margin:20px;'
      class='lu-flex menu-tree'
      :indent='0'
      node-key='functionId'
      default-expand-all
      :key='"tree-" + readonly'
      :expand-on-click-node="false"
    >


      <span class='menu-tree-row' slot-scope="{ node, data }" >
        <span class='menu-tree-node-label'>
          <span>{{ indent(node.level - 1) }}</span>
          <span>{{ data.brokerName}} </span>
        </span>
        <span class='menu-tree-node-content' @click.stop >
          <lu-hbox>
            <lu-item v-for='perm in data.brokerList' :key='perm.functionId'>
              <el-checkbox :disabled='readonly' :label='perm.label' @change='e => onChangeLeaf(perm, e)' style='width: 100px; margin-right: 50px' v-model='perm.isAllowed'/>
            </lu-item>
          </lu-hbox>

        </span>
      </span>

    </el-tree>
  </lu-vbox>

</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import PageTitle from '@/components/PageTitle'

export default {
  name: 'BrokerTree',
  components: { PageTitle, LuHbox, LuVbox, LuItem },
  props: {
    tree: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    fontClass: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      model: this.tree,
      folded: {}
    }
  },
  computed: {
  },
  watch: {
    tree: function () {
      this.model = this.tree
    }
  },
  created () {
  },
  methods: {
    togglePageTitle () {
    },
    indent: function (j = 0) {
      let indent = ''
      for (let i = 0; i < j; i++) {
        indent += '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'
      }
      return indent
    },
    disallowRec: function (node, first) {
      if (!first) node.isAllowed = false
      for (let i = 0; i < node.children.length; i++) {
        this.disallowRec(node.children[i], false)
      }
      for (let i = 0; i < node.leaves.length; i++) {
        this.disallowRec(node.leaves[i], false)
      }
    },
    allowRec: function (node, first) {
      if (!first) node.isAllowed = true
      if (node.parent) this.allowRec(node.parent, false)
    },
    onChangeAccess: function (node, val) {
      if (!val) this.disallowRec(node, true)
      if (val) this.allowRec(node, true)
    },
    onChangeLeaf: function () {
    },
    getModel: function () {
      return this.model
    }
  }
}
</script>

<style >
.el-tree-node:focus {
  outline-color: transparent !important;
}
</style>
